<div
  class="co-confirmation"
  [ngClass]="{ 'co-confirmation--skl': env === 'skl' }"
>
  <div id="conf-personal-data" class="uk-form-horizontal">
    <h1>Ihre Bestellung</h1>
    <div class="co-confirmation__headline">
      <h2 class="uk-h3">Persönliche Daten</h2>
      <a
        href=""
        [routerLink]="showCartPage ? '/bestellen' : '/landing'"
        [fragment]="showCartPage ? '' : 'personal-data-headline'"
        class="co-confirmation__change"
        >Ändern</a
      >
    </div>
    <div class="co-form-group clearfix row uk-grid-collapse" uk-grid>
      <div class="small-12 medium-3 columns uk-width-1-1 uk-width-1-3@m">
        <label for="">Anrede</label>
      </div>
      <div class="small-12 medium-9 columns uk-width-1-1 uk-width-2-3@m">
        {{
          addressData.salutation === 'Divers'
            ? 'Keine Angabe'
            : addressData.salutation
        }}
      </div>
    </div>
    <div class="co-form-group clearfix row uk-grid-collapse" uk-grid>
      <div class="small-12 medium-3 columns uk-width-1-1 uk-width-1-3@m">
        <label for="">Vorname</label>
      </div>
      <div class="small-12 medium-9 columns uk-width-1-1 uk-width-2-3@m">
        {{ addressData.firstName }}
      </div>
    </div>
    <div class="co-form-group clearfix row uk-grid-collapse" uk-grid>
      <div class="small-12 medium-3 columns uk-width-1-1 uk-width-1-3@m">
        <label for="">Nachname</label>
      </div>
      <div class="small-12 medium-9 columns uk-width-1-1 uk-width-2-3@m">
        {{ addressData.lastName }}
      </div>
    </div>
    <div class="co-form-group clearfix row uk-grid-collapse" uk-grid>
      <div class="small-12 medium-3 columns uk-width-1-1 uk-width-1-3@m">
        <label for="">Straße / Hausnummer</label>
      </div>
      <div class="small-12 medium-9 columns uk-width-1-1 uk-width-2-3@m">
        {{ addressData.street }}
        {{ addressData.streetNumber }}
      </div>
    </div>
    <div class="co-form-group clearfix row uk-grid-collapse" uk-grid>
      <div class="small-12 medium-3 columns uk-width-1-1 uk-width-1-3@m">
        <label for="">Postleitzahl</label>
      </div>
      <div class="small-12 medium-9 columns uk-width-1-1 uk-width-2-3@m">
        {{ addressData.zip }}
      </div>
    </div>
    <div class="co-form-group clearfix row uk-grid-collapse" uk-grid>
      <div class="small-12 medium-3 columns uk-width-1-1 uk-width-1-3@m">
        <label for="">Stadt</label>
      </div>
      <div class="small-12 medium-9 columns uk-width-1-1 uk-width-2-3@m">
        {{ addressData.cities }}
      </div>
    </div>
    <div class="co-form-group clearfix row uk-grid-collapse" uk-grid>
      <div class="small-12 medium-3 columns uk-width-1-1 uk-width-1-3@m">
        <label for="">Land</label>
      </div>
      <div class="small-12 medium-9 columns uk-width-1-1 uk-width-2-3@m">
        {{ addressData.country }}
      </div>
    </div>
    <div class="co-form-group clearfix row uk-grid-collapse" uk-grid>
      <div class="small-12 medium-3 columns uk-width-1-1 uk-width-1-3@m">
        <label for="">E-Mail-Adresse</label>
      </div>
      <div class="small-12 medium-9 columns uk-width-1-1 uk-width-2-3@m">
        {{ addressData.email }}
      </div>
    </div>
    <div
      class="co-form-group clearfix row uk-grid-collapse"
      uk-grid
      *ngIf="addressData.phoneNumber"
    >
      <div class="small-12 medium-3 columns uk-width-1-1 uk-width-1-3@m">
        <label for="">Telefon</label>
      </div>
      <div class="small-12 medium-9 columns uk-width-1-1 uk-width-2-3@m">
        {{ addressData.phoneNumber }}
      </div>
    </div>
    <div class="co-form-group clearfix row uk-grid-collapse" uk-grid>
      <div class="small-12 medium-3 columns uk-width-1-1 uk-width-1-3@m">
        <label for="">Geburtsdatum</label>
      </div>
      <div class="small-12 medium-9 columns uk-width-1-1 uk-width-2-3@m">
        {{ addressData.birthday }}
      </div>
    </div>
    <div class="co-form-group clearfix row uk-grid-collapse" uk-grid>
      <div class="small-12 medium-3 columns uk-width-1-1 uk-width-1-3@m">
        <label for="">Geburtsname</label>
      </div>
      <div class="small-12 medium-9 columns uk-width-1-1 uk-width-2-3@m">
        {{ addressData.birthName }}
      </div>
    </div>
    <div class="co-form-group clearfix row uk-grid-collapse" uk-grid>
      <div class="small-12 medium-3 columns uk-width-1-1 uk-width-1-3@m">
        <label for="">Geburtsort</label>
      </div>
      <div class="small-12 medium-9 columns uk-width-1-1 uk-width-2-3@m">
        {{ addressData.birthplace }}
      </div>
    </div>
  </div>

  <div id="conf-bank-details">
    <div class="co-confirmation__headline">
      <h2 class="uk-h3">Zahlungsart</h2>
      <a
        href=""
        [routerLink]="showCartPage ? '/bestellen' : '/landing'"
        [fragment]="showCartPage ? '' : 'payment-data-headline'"
        class="co-confirmation__change"
        >Ändern</a
      >
    </div>

    <div *ngIf="addressData.paymentType === 'paypal'">
      <h3 class="uk-h4">PayPal</h3>
      <p>
        Nachdem Sie Ihre Losbestellung getätigt haben, werden Sie direkt zu
        PayPal weitergeleitet.
      </p>
    </div>

    <div *ngIf="addressData.paymentType === 'ibanWithSepa'">
      <h3 class="uk-h4">SEPA Lastschriftmandat</h3>
      <div class="co-form-group clearfix row uk-grid-collapse" uk-grid>
        <div class="small-12 medium-3 columns uk-width-1-1 uk-width-1-3@m">
          <label for="">Kontoinhaber</label>
        </div>
        <div class="small-12 medium-9 columns uk-width-1-1 uk-width-2-3@m">
          {{ addressData.firstName }}
          {{ addressData.lastName }}
        </div>
      </div>
      <div class="co-form-group clearfix row uk-grid-collapse" uk-grid>
        <div class="small-12 medium-3 columns uk-width-1-1 uk-width-1-3@m">
          <label for="">IBAN</label>
        </div>
        <div class="small-12 medium-9 columns uk-width-1-1 uk-width-2-3@m">
          {{ addressData.iban }}
        </div>
      </div>
      <div
        class="co-form-group clearfix row uk-grid-collapse"
        uk-grid
        *ngIf="payment === 'account'"
      >
        <div class="small-12 medium-3 columns uk-width-1-1 uk-width-1-3@m">
          <label for="">BLZ</label>
        </div>
        <div class="small-12 medium-9 columns uk-width-1-1 uk-width-2-3@m">
          {{ addressData.bankCode }}
        </div>
      </div>
      <div class="co-form-group clearfix row uk-grid-collapse" uk-grid>
        <div class="small-12 medium-3 columns uk-width-1-1 uk-width-1-3@m">
          <label for="">Name der Bank</label>
        </div>
        <div class="small-12 medium-9 columns uk-width-1-1 uk-width-2-3@m">
          {{ addressData.bank }}
        </div>
      </div>
      <div
        class="co-form-group clearfix row uk-grid-collapse"
        *ngIf="!showCartPage && !hasSepa"
        uk-grid
      >
        <div class="small-12 medium-3 columns uk-width-1-1 uk-width-1-3@m">
          <label for="">Zahlungsart</label>
        </div>
        <div class="small-12 medium-9 columns uk-width-1-1 uk-width-2-3@m">
          Rechnung
        </div>
      </div>
    </div>
  </div>

  <app-coupon
    [hideCouponForm]="hideCouponForm"
    [couponConfirmation]="couponConfirmation"
    *ngIf="showCartPage"
  ></app-coupon>

  <app-summary></app-summary>

  <div
    class="co-form-group legals co-text-legal"
    [ngClass]="{ 'legals--skl': showCartPage }"
  >
    <p>
      Es gelten die
      <a href="#" (click)="openModal('termsOfPlay')">ALB und ergänzenden ALB</a>
      <a
        href="#lp-modal-termsOfPlay"
        *ngIf="!showCartPage && false"
        id="lp-link-termsOfPlay"
        uk-toggle
        >ALB und ergänzenden ALB</a
      >
      für die Teilnahme im Internet sowie unsere
      <a href="#" (click)="openModal('termsOfUse')">Nutzungsbedingungen</a
      ><a
        href="#lp-modal-termsOfUse"
        *ngIf="!showCartPage && false"
        id="lp-link-termsOfUse"
        uk-toggle
        >Nutzungsbedingungen</a
      >. Bitte beachten Sie die Informationen zum
      <a href="#" (click)="openModal('privacy')">Datenschutz</a
      ><a
        href="#lp-modal-privacy"
        id="lp-link-privacy"
        *ngIf="!showCartPage && false"
        uk-toggle
        >Datenschutz</a
      >
      und zur
      <a href="#" (click)="openModal('ageVerification')">Altersverifikation</a
      ><a
        href="#lp-modal-ageVerification"
        id="lp-link-ageVerification"
        *ngIf="!showCartPage && false"
        uk-toggle
        >Altersverifikation</a
      >. Wir informieren Sie per E-Mail über eigene ähnliche Angebote und
      Produkte. Sie können der Verwendung Ihrer E-Mail-Adresse hierfür jederzeit
      widersprechen per E-Mail an
      <a href="mailto:widerspruch@gloeckle.de">widerspruch@gloeckle.de</a>, ohne
      dass hierfür andere als die Übermittlungskosten nach den Basistarifen
      entstehen.
      <a
        href="https://www.gloeckle.de/datenschutz"
        target="_blank"
        rel="noopener"
        >Weitere Infos</a
      >. <a href="#" (click)="toggleLimit()">Spiellimit anpassen?</a>
    </p>
  </div>

  <app-limit
    *ngIf="showLimit"
    [userLimit]="maxMonthlyCosts"
    (limitFormOutput)="onLimitFormChange($event)"
  ></app-limit>

  <div class="co-confirmation__error" *ngIf="orderErrorMessages.length">
    <p *ngFor="let msg of orderErrorMessages">{{ msg }}</p>
  </div>

  <app-login-alert
    class="co-confirmation__login-alert"
    [showLoginPhrase]="false"
    *ngIf="
      !isLoggedIn &&
      orderErrorOrigin === 'found user with same email but not logged in'
    "
  ></app-login-alert>

  <footer class="co-content__footer uk-text-center">
    <button
      class="uk-button uk-button-primary"
      (click)="submitOrder()"
      id="ctaConversion"
      [disabled]="!confirmationIsValid || submitLoading"
    >
      Jetzt kaufen
    </button>
  </footer>
</div>
